/**
 * Convert a string to title case
 * @example 'hello World, what's uP?' -> 'Hello World, What's Up?'
 * @param str
 * @returns
 */
export function titleCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

/**
 * Returns true if a string is null or empty
 */
export function isNullOrEmpty(str: string) {
  return str === null || str === undefined || str === '';
}

/**
 * Returns null if string is empty, otherwise returns the string
 */
export function nullifyEmpty(str: string) {
  return isNullOrEmpty(str) ? null : str;
}

/**
 * Convert URL pathname to a slug by removing all slashes
 */
export function pathToSlug(pathname: string): string {
  return pathname
    .replace(/^\/+|\/+$/g, '') // Remove leading and trailing slashes
    .replace(/\//g, ''); // Remove remaining slashes
}
